import { Modal, useDeviceType } from '@cian/ui-kit';
import React, { useCallback, useState } from 'react';

import styles from './styles.css';

import cn from 'clsx';
import { ProgramGuideModalContent } from './ProgramGuideModalContent';

export interface IProgramGuideModalProps {
  open: boolean;
  onClose: () => void;
}

export const ProgramGuideModal: React.FC<IProgramGuideModalProps> = ({ open, onClose }) => {
  const [contentKey, setContentKey] = useState(0);
  const deviceType = useDeviceType();

  const handleClose = useCallback(() => {
    onClose();
    setContentKey(prev => prev + 1);
  }, [onClose]);

  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        handleClose();
      }
    },
    [handleClose],
  );

  return (
    <Modal
      className={cn(deviceType === 'phone' && styles['full-height'])}
      open={open}
      onOpenChange={handleOpenChange}
      size="M"
    >
      <ProgramGuideModalContent key={contentKey} onClose={handleClose} />
    </Modal>
  );
};

ProgramGuideModal.displayName = 'ProgramGuideModal';
